import {
  CGV2LocationOutDTO,
  ExpeditionTypeEnum,
  InvoiceStateEnum,
  LabelPreviewWithoutTypeOutDTO,
  LovDTO, NotifyTargetInnerInDTO, PolandSentRequest,
  SaveExpeditionLocationRequestInDTO, SupplierNotificationPreviewOutDTO,
  TransportationTypeEnum,
  UpdateExpeditionIncotermsRequest,
} from '@api/ringil-api.v2.tsx';
import { UploadedAttachment } from '@components/ringil3/Features/Attachments/UploadAttachmentDialog.tsx';
import { CargoType } from '@components/framework/input/InputCargoType/InputCargoType.tsx';
import { RebillingType } from '@components/framework/tags/InternalInfoRebillingTag.tsx';
import {
  CarrierDistributionSelectorData,
} from '@components/RingilComponents/CarrierDistributionSelector/CarrierDistributionSelector.tsx';

interface ExpeditionLocation extends CGV2LocationOutDTO {}

export enum LocalityEntryModeEnum {
  MANUALLY = 'MANUALLY',
  FROM_LOCATIONS = 'FROM_LOCATIONS',
}

export interface ManualAddress {
  name?: string;
  postalCode?: string;
  countryCode3?: string;
  city?: string;
  streetNr?: string;
  mainContactPerson?: string;
  mainContactPhone?: string;
  mainContactEmail?: string;
  notifySelectedPerson?: boolean;
  additionalPersons?: AdditionalPerson[];
  timezoneId?: string;
}

export interface ExpeditionLocality extends SaveExpeditionLocationRequestInDTO {
  localityMode: LocalityEntryModeEnum;
  location: ExpeditionLocation;
  manualAddress: ManualAddress;
  additionalPersons?: AdditionalPerson[];
  // this is using for animation
  id: string;
  /**
   * Set by the prefill when this stop's location had been superseded and was swapped for its
   * replacement: the name of the location the source shipment actually used. Display only — it marks
   * the swap for the user and is never sent (mapLocation builds the request field by field).
   */
  supersededFromLocationName?: string;
}

export interface AdditionalPerson {
  name: string;
  email: string;
}

export interface NewExpeditionForm {
  locations: ExpeditionLocality[];
  distribution: CarrierDistributionSelectorData;
  specialRequirements?: string[];
  carrierNote?: string;
  transportationType?: TransportationTypeEnum;
  expeditionType?: ExpeditionTypeEnum;
  loadingTypes?: string[];
  truckTypeCode?: string;
  cargoType?: CargoType;
  persons?: LovDTO[];
  person?: LovDTO;
  /** RD-2977: an expedition can be filed in several folders */
  folders?: LovDTO[];
  notifyByRole?: boolean;
  invoiceState?: InvoiceStateEnum;
  disponentPerson?: LovDTO;
  pairingSymbol?: string;
  internalNote?: string;
  rebilling?: RebillingType;
  attachments?: UploadedAttachment[];
  customApplicationId?: string;
  name?: string;
  labels?: LabelPreviewWithoutTypeOutDTO[];
  incoterms?: UpdateExpeditionIncotermsRequest;
  customsDeclarationCompanies?: LovDTO[];
  internalInfoAccountCodeListId?: string;
  internalInfoCostCenterCodeListId?: string;
  internalInfoCostUnitCodeListId?: string;
  internalInfoProjectCodeListId?: string;
  huEkaerNumber?: string;
  roUitNumber?: string;
  utnCode?: string;
  polandSent?: PolandSentRequest;
  notifiedTargets?: NotifyTargetInnerInDTO[];
  supplierNotificationLink?: SupplierNotificationPreviewOutDTO;
}
